'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SxProps, Theme } from '@mui/material';
import type { GridBaseProps } from '@mui/material/Grid';
import Grid from '@mui/material/Grid';
import { AnimatePresence, motion } from 'framer-motion';
import { VehicleMediaCard } from '@/components/Vehilces/VehicleMediaCard';
import { mergeSx } from '@/lib/mergeSx';
import type { CmsVehicle } from '@/services/cms/models/CmsVehicle';
export interface VehicleGridProps {
  vehicles: CmsVehicle[];
  sx?: SxProps<Theme>;
  noResults?: React.ReactNode;
  enquireFormOnCompleteMessage?: string;
  siteId?: number;
}
export function VehicleGrid(t0) {
  const $ = _c(12);
  const {
    vehicles,
    noResults,
    enquireFormOnCompleteMessage,
    siteId,
    sx
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = mergeSx(sx, {
      "& img": {
        transition: ".35s",
        willChange: "transform"
      }
    });
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== enquireFormOnCompleteMessage || $[3] !== noResults || $[4] !== siteId || $[5] !== vehicles) {
    t2 = vehicles.length === 0 ? <VehicleGridColumn size={12}>{noResults}</VehicleGridColumn> : vehicles.map(vehicle => <VehicleGridColumn key={vehicle.id}><VehicleMediaCard vehicle={vehicle} enquireFormOnCompleteMessage={enquireFormOnCompleteMessage} siteId={siteId} /></VehicleGridColumn>);
    $[2] = enquireFormOnCompleteMessage;
    $[3] = noResults;
    $[4] = siteId;
    $[5] = vehicles;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <Grid container={true} spacing={2} sx={t1}>{t3}</Grid>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
type VehicleGridColumnProps = {
  children: React.ReactNode;
  size?: GridBaseProps['size'];
};
function VehicleGridColumn(t0) {
  const $ = _c(8);
  const {
    children,
    size: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      xs: 12,
      sm: 6,
      md: 4
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const size = t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 1,
      scale: 1
    };
    t4 = {
      opacity: 0,
      scale: 0.95
    };
    t5 = {
      duration: 0.3
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== size) {
    t6 = <Grid component={motion.div} size={size} initial={false} animate={t3} exit={t4} transition={t5} layout="position">{children}</Grid>;
    $[5] = children;
    $[6] = size;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}